import { Set } from "immutable";
import { createSelector } from "reselect";

import { makeGetCourseLeafSectionIds } from "seneca-common/features/course/state";
import { getStudiedSectionIds } from "seneca-common/features/stats/state";

export function selectStudiedSectionIdsFromCourse(courseId: string) {
  const getLeafSectionIds = makeGetCourseLeafSectionIds(courseId);

  return createSelector(
    getStudiedSectionIds,
    getLeafSectionIds,
    (studiedSectionIds, leafSectionIds) => {
      return Set.intersect<string>([
        leafSectionIds,
        studiedSectionIds
      ]).toList();
    }
  );
}
